module.exports = __webpack_public_path__ + "static/media/KoreaFlag.8279abd9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/KoreaFlag.webp
// module id = 187
// module chunks = 0